import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { toast } from 'sonner';
import { api } from '../../services/api';

export const OfferModal = ({
  showOfferModal, setShowOfferModal, offerForm, setOfferForm,
  setTab, fetchData, formatCurrency,
}) => (
  <Dialog open={!!showOfferModal} onOpenChange={() => setShowOfferModal(null)}>
    <DialogContent className="bg-[#0A0A0A] border-[#262626] max-w-md" data-testid="offer-modal">
      <DialogHeader><DialogTitle className="font-serif text-white">Make a Custom Offer</DialogTitle></DialogHeader>
      {showOfferModal && (
        <div className="space-y-4">
          <div className="p-3 bg-[#0F0F0F] border border-[#1A1A1A] rounded">
            <p className="text-white text-sm font-medium">{showOfferModal.asset_name}</p>
            <p className="text-[11px] text-muted-foreground">List price: {formatCurrency(showOfferModal.price_per_fraction)} / fraction · {showOfferModal.fractions_available?.toLocaleString()} available</p>
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-muted-foreground">Your offer per fraction (£)</label>
            <Input type="number" step="0.01" min="0.01" value={offerForm.price} onChange={e => setOfferForm({...offerForm, price: e.target.value})} className="luxury-input mt-1" data-testid="offer-price-input" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-muted-foreground">Number of fractions</label>
            <Input type="number" min="1" max={showOfferModal.fractions_available} value={offerForm.fractions} onChange={e => setOfferForm({...offerForm, fractions: e.target.value})} className="luxury-input mt-1" data-testid="offer-fractions-input" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-muted-foreground">Note to seller (optional)</label>
            <Input value={offerForm.message} onChange={e => setOfferForm({...offerForm, message: e.target.value})} className="luxury-input mt-1" placeholder="e.g. Long-term holder, can complete this week" />
          </div>
          <div className="p-3 bg-[#0F0F0F] border border-[#262626] rounded text-xs flex justify-between">
            <span className="text-muted-foreground">Total if accepted</span>
            <span className="text-gold font-semibold">{formatCurrency((parseFloat(offerForm.price) || 0) * (parseInt(offerForm.fractions) || 0))}</span>
          </div>
          <p className="text-[10px] text-muted-foreground italic">If accepted, you'll be notified to complete payment via Stripe. Offers expire after 72 hours.</p>
          <Button data-testid="submit-offer-btn" onClick={async () => {
            const price = parseFloat(offerForm.price);
            const fractions = parseInt(offerForm.fractions);
            if (!price || price <= 0 || !fractions || fractions <= 0) { toast.error('Enter a valid price and quantity'); return; }
            try {
              await api.createOffer({ token_id: showOfferModal.id, price_per_fraction: price, fractions, message: offerForm.message });
              toast.success('Offer submitted. The seller has been notified.');
              setShowOfferModal(null);
              setTab('offers');
              fetchData();
            } catch (e) {
              toast.error(e.response?.data?.detail || 'Failed to submit offer');
            }
          }} className="w-full bg-gold text-black hover:bg-gold/90">
            Submit Offer
          </Button>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
